import { apiSlice } from "../../app/api/apiSlice"
import { generateFormatedURL } from "../../utils/urlFormatter"

export const alertApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAlertListing: builder.query({
            query: (args) => `/alert`.concat(generateFormatedURL(args)),
        }),
        getAlertDetail: builder.query({
            query: (id) => `/alert/${id}`,
        }),
    })
})

export const {
    useLazyGetAlertListingQuery,
    useLazyGetAlertDetailQuery,
} = alertApiSlice  